<template>
<div class="chapter">
<div class="inner_page">
<p class="label"><a id="page_1"></a><a id="pt1"></a>PART ONE</p>
<p class="h2a"><em>The Dominance of the East</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226308128_11_pt1.vue?8d15045a